module.exports = __webpack_public_path__ + "static/media/giphy.ac33d903.gif";